import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import qs from 'qs'

import ProductsCardList from '../../components/ProductsCardList'
import FooterButton from '../../components/FooterButton'
import Paginate from '../../components/Paginate'
import WishListTitle from '../../components/WishListTitle'
import ModalMessage from '../../components/ModalMessage'
import ContentBetweenLines from '../../components/ContentBetweenLines'
import SettingsContainer from '../../components/SettingsContainer'
import Button from '../../components/Button'
import Search from '../../components/SearchModal'
import ButttonTop from '../../components/ButtonTop'
import ProductZoomModal from '../../components/ProductZoomModal'
import Nps from '../../components/Nps'
import Tutorial from '../../components/Tutorial'
import Home from '../../components/Home'

import useUser from '../../hooks/UserContext'
import useFilter from '../../hooks/FilterContext'
import useWishList from '../../hooks/WishListContext'
import useSearch from '../../hooks/SearchContext'
import MaisConteudoAPi from '../../services/MaisConteudoAPi'
import { orderInformations } from '../../utils/filterInformations'
import { onDisabledScrollHandler, onEnableScrollHandler, windowScreenWidth } from '../../utils/ScrollHandler'
import SendGTAGEvent from '../../utils/sendGTAGEvent'
import { storedEnv } from '../../utils/localStorage'
import { ReactComponent as PlusSvg } from '../../assets/plus.svg'
import { ReactComponent as SearchSvg } from '../../assets/search.svg'
import { ReactComponent as CloseButtonSvg } from '../../assets/ExitDelete.svg'

import {
    Container,
    FooterButtonNameCreateWishList,
    FooterButtonNameCreateWishListOut,
    ProductsHeaderContainer,
    ContainerTextSearch,
    TextSearchItem
} from './styles'

interface IFilter {
    env: string;
    search: string;
    priceRange: number[];
    size: string;
    color: string;
    category: string;
    brand: string;
}

interface ICategory {
    search: string;
    category: string;
    brand: string;
}

interface IOrder {
    order: string;
}

interface IPaginateParamsState {
    to: number;
    from: number;
    searchedText: string | undefined;
}

interface IDataState {
    items: {
        images: {
            imageUrl: string;
        }[]

        sellers: {
            sellerName: string;
            commertialOffer: {
                Price: number;
                ListPrice: number;
                AvailableQuantity: number;
            };
        }[]
    }[];
    linkText: string;
    productName: string;
    productReference: string;
}

interface ISettingsModals {
    filter: boolean;
    order: boolean;
    category: boolean;
}

interface IFilterStates {
    env: boolean;
    priceRange: boolean;
    size: boolean;
    color: boolean;
    category: boolean;
    search: boolean;
}

export interface IZoomModal {
    img: string;
    name: string;
    ref: string;
    href: string;
    price: {
        oldPrice: number;
        discountPrice: number;
    }
}
const Products: React.FC = () => {

    const items_per_page = 20

    const [filter, setFilter] = useState<IFilter | any>({ env: storedEnv })
    const [category, setCategory] = useState<ICategory | any>({ search: 'todos' })
    const [order, setOrder] = useState<IOrder | any>({})
    const [paginateParams, setPaginateParams] = useState<IPaginateParamsState>({ to: items_per_page - 1, from: 0, searchedText: undefined })
    const [data, setData] = useState<IDataState[]>([])
    const [isOpenModalsSettings, setIsOpenModalsSettings] = useState<ISettingsModals>({ filter: false, order: false, category: false })
    const [filterStates, setFilterStates] = useState<IFilterStates>({ env: false, priceRange: false, size: false, color: false, category: false, search: false })
    const [successModalIsOpen, setSuccessModalIsOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string>('')
    const [isVisibleButtonTop, setVisibleButtonTop] = useState(false)
    const [zoomModal, setZoomModal] = useState<IZoomModal>({ img: '', href: '', name: '', ref: '', price: { discountPrice: 0, oldPrice: 0 } })
    const [isOpenZoomModal, setIsOpenZoomModal] = useState<boolean>(false)
    const [isOpenNps, setIsOpenNps] = useState<boolean>(false)
    const [isOpenProducts, setIsOpenProducts] = useState<boolean>(true)
    const [shouldHideDeviceFilterBrand, setShouldHideDeviceFilterBrand] = useState<boolean>(true)
    const [shouldHideDeviceFilterCategory, setShouldHideDeviceFilterCategory] = useState<boolean>(true)
    const [shouldHideDeviceFilterNews, setShouldHideDeviceFilterNews] = useState<boolean>(true)
    const [shouldHideBrand, setShouldHideBrand] = useState<boolean>(true)
    const [shouldHideCategory, setShouldHideCategory] = useState<boolean>(true)
    const [shouldHideNews, setShouldHideNews] = useState<boolean>(true)

    const { userBrandsMemo, userInfo } = useUser()
    const { colorsBrandMemo, sizesBrandMemo, categorysBrandMemo } = useFilter()
    const { wishListIsOpen, openedWishList, onCloseWishListHandler, onShareLinkHandler, onShareLinkWithParamsHandler } = useWishList()
    const navigate = useNavigate()
    const { isOpenSearch, onOpenCloseSearchHandler, onShowButtonSearchHandler } = useSearch()
    const mounted = useRef(false)

    const getValuesOffPremium = userBrandsMemo.filter(brand => brand.filterItemValue === 'lojaoffpremium');

    const filterConfigsMemo = useMemo(() => ([
        {
            filterName: 'env',
            filterTitle: 'marcas',
            filterType: 'radio',
            filterItems: getValuesOffPremium,
            shouldHide: shouldHideDeviceFilterBrand,
            isOpen: filterStates.env
        },
        {
            filterName: 'size',
            filterTitle: 'tamanhos',
            filterType: 'radio',
            filterItems: sizesBrandMemo,
            shouldHide: false,
            isOpen: filterStates.size
        },
        {
            filterName: 'color',
            filterTitle: 'cores',
            filterType: 'radio',
            filterItems: colorsBrandMemo,
            shouldHide: false,
            isOpen: filterStates.color
        },
        {
            filterName: 'search',
            filterTitle: 'produtos',
            filterType: 'radio',
            filterItems: [
                { filterItemName: 'novidades', filterItemValue: 'novidades' },
                { filterItemName: 'todos os produtos', filterItemValue: 'todos' },
                { filterItemName: 'bazar', filterItemValue: 'bazar' }
            ],
            shouldHide: shouldHideDeviceFilterNews,
            isOpen: filterStates.search
        },
        {
            filterName: 'category',
            filterTitle: 'categorias',
            filterType: 'radio',
            filterItems: categorysBrandMemo,
            shouldHide: shouldHideDeviceFilterCategory,
            isOpen: filterStates.category
        },
        {
            filterName: 'priceRange',
            filterTitle: 'preço',
            filterType: 'range',
            filterItems: [{ filterItemName: 'valores', filterItemValue: [] }],
            shouldHide: false,
            isOpen: filterStates.priceRange
        },
    ]

    ), [getValuesOffPremium, shouldHideDeviceFilterBrand, filterStates.env, filterStates.size, filterStates.color, filterStates.priceRange, filterStates.category, filterStates.search, sizesBrandMemo, colorsBrandMemo, categorysBrandMemo, shouldHideDeviceFilterCategory, shouldHideDeviceFilterNews])

    const filterConfigsCategoryMemo = useMemo(() => ([
        {
            filterName: 'brand',
            filterTitle: 'marcas',
            filterType: 'radio',
            filterCategoryItems: getValuesOffPremium,
            shouldHide: shouldHideBrand,
            isOpen: filterStates.env
        },

        {
            filterName: 'category',
            filterTitle: 'categorias',
            filterType: 'radio',
            filterCategoryItems: categorysBrandMemo,
            shouldHide: shouldHideCategory,
            isOpen: filterStates.category
        },
        {
            filterName: 'search',
            filterTitle: 'produtos',
            filterType: 'radio',
            filterCategoryItems: [
                { filterItemName: 'novidades', filterItemValue: 'novidades' },
                { filterItemName: 'todos os produtos', filterItemValue: 'todos' },
                { filterItemName: 'bazar', filterItemValue: 'bazar' }
            ],
            shouldHide: shouldHideNews,
            isOpen: filterStates.search
        },
    ]

    ), [getValuesOffPremium, shouldHideBrand, filterStates.env, filterStates.category, filterStates.search, categorysBrandMemo, shouldHideCategory, shouldHideNews])

    const orderConfigsMemo = useMemo(() => ({
        orderMobileConfigs: orderInformations.orderItems.map(orderInformation => ({ key: 'order', ...orderInformation })),
        orderDesktopConfigs: orderInformations.orderItems.map(orderInformation => ({ key: 'order', ...orderInformation }))
    }), [])

    const activeFiltersCounteMemo = useMemo(() => {
        let doNotCount = ['env', 'search']

        if (filter.env === 'lojafarm') {
            doNotCount = ['env', 'search']
        }

        return Object.keys(filter)
            .filter(filterKey => !doNotCount.includes(filterKey))
            .length
    }, [filter])

    const activeCategoryCounteMemo = useMemo(() => {
        let doNotCount = ['env', 'size', 'color', 'priceRange', 'search']

        if (filter.env === 'lojafarm') {
            doNotCount = ['env', 'size', 'color', 'priceRange']
        }

        return Object.keys(category)
            .filter(filterKey => !doNotCount.includes(filterKey))
            .length
    }, [category, filter.env])

    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setVisibleButtonTop(true)
        } else {
            setVisibleButtonTop(false)
        }
    }
    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility)
        return () => {
            window.removeEventListener('scroll', toggleVisibility)
        }
    }, [])
    const transformParamsInStringMemo = useMemo(() => {
        const to = paginateParams.to
        const from = paginateParams.from
        let text = undefined
        let code = undefined

        let paramEnv = ''
        let complementTextOrCode = '?'
        let complementURL = '/'
        let brand = category.brand || filter.brand
        let env = filter.env

        const typeSearch = paginateParams.searchedText?.charAt(0)
        if (typeSearch) {
            const isText = isNaN(parseInt(typeSearch))
            text = isText ? paginateParams.searchedText : undefined
            code = isText ? undefined : paginateParams.searchedText
            paramEnv = filter.env
        }

        const isValidUrl = (string: any) => {
            try {
                const getURL = new URL(string)
                return getURL.pathname
            } catch (err) {
                return 'false';
            }
        }
        const valuesJoinFilter: any = {};

        for (const key in filter) {
            if (key !== 'priceRange' && key !== 'category' && Array.isArray(filter[key])) {
                valuesJoinFilter[key] = filter[key].join(",");
            }
            else {
                valuesJoinFilter[key] = filter[key]
            }
        }

        let search = filter.search ?? category.search
        let getSearchParam = text

        let newParamsObjt = { page: { to, from }, ...valuesJoinFilter, ...category, ...order, ...category, env, text, code, brand, search }
        let urlParams = isValidUrl(getSearchParam).slice(0, -1)

        const productsParam = complementTextOrCode.concat(qs.stringify(newParamsObjt))
        const linkParam = complementURL.concat(paramEnv.concat(urlParams))

        if (isValidUrl(getSearchParam) === 'false') { return productsParam }
        else { return linkParam }

    }, [paginateParams.to, paginateParams.from, paginateParams.searchedText, filter, category, order])

    const checkIfHasMore = useMemo(() => (data.length === 0 && loading) || (data.length > 0), [data, loading])

    const onNextPaginateHandler = useCallback(() => {
        setPaginateParams((prevState: IPaginateParamsState) => ({ ...prevState, to: prevState.to + items_per_page, from: prevState.from + items_per_page }))
    }, [])

    const onSearchTextHandler = useCallback((text: string | undefined) => {
        setPaginateParams({ to: items_per_page - 1, from: 0, searchedText: text })
        setData([])
    }, [])

    const onCloseNpsHandler = useCallback(() => {
        setIsOpenNps(false)
        onEnableScrollHandler()
    }, [])

    const onOpenNpsHandler = useCallback(() => {
        setIsOpenNps(true)
    }, [])


    const onFetchDataHandler = useCallback(async () => {
        try {
            setLoading(true)
            const res = await MaisConteudoAPi.get(`/v1/products${transformParamsInStringMemo}`)
            if (mounted.current) {
                setData((prevState: any) => (prevState.concat(res.data)))
                setLoading(false)
            }
        } catch (error: any) {
            setLoading(false)
            setError(error.response?.data.message || 'Algo de errado aconteceu, tente novamente!')
        }
    }, [transformParamsInStringMemo])

    const onClearDataAndPaginate = useCallback((clearText: boolean = false) => {
        setPaginateParams(prev => ({
            to: items_per_page - 1,
            from: 0,
            searchedText: clearText ? undefined : prev.searchedText
        }))
        setData([])
    }, [])

    const onOpenAndCloseModalSettingsHandler = useCallback((stateKey: string) => {
        if (!windowScreenWidth()) { setFilterStates({ category: true, color: true, env: true, priceRange: true, size: true, search: true }) }

        return setIsOpenModalsSettings((prevState: ISettingsModals | any) => {
            let newState = { ...prevState }

            for (let key in newState) {
                if (stateKey === key) {
                    if (newState[stateKey]) {
                        newState = { ...newState, [stateKey]: false }
                        continue
                    }
                    newState = { ...newState, [stateKey]: true }
                    continue
                }
                newState = { ...newState, [key]: false }
            }
            return newState
        })
    }, [])

    const onCloseAllModalSettingsHandler = useCallback(() => setIsOpenModalsSettings({ filter: false, order: false, category: false }), [])


    const onOpenModalSuccessHandler = useCallback(() => {
        onDisabledScrollHandler()
        return setSuccessModalIsOpen(true)
    }, [])

    const onCloseModalSuccessHandler = useCallback(() => {
        onEnableScrollHandler()
        setSuccessModalIsOpen(false)
        onCloseWishListHandler()
        navigate('/my-wishlists')
    }, [navigate, onCloseWishListHandler])

    const onClickActionModalSuccessHandler = useCallback(() => {
        openedWishList.linkName ?
            onShareLinkWithParamsHandler()
            :
            onShareLinkHandler()
        onCloseModalSuccessHandler()
        SendGTAGEvent(
            'compartilha_lojinha',
            'Lojinha',
            'Clica em compartilhar lojinha',
            openedWishList.linkId
        )
    }, [openedWishList.linkName, openedWishList.linkId, onShareLinkWithParamsHandler, onShareLinkHandler, onCloseModalSuccessHandler])

    const onClearErrorHandler = useCallback(() => {
        setError('')
        SendGTAGEvent(
            'modal_error',
            'Erros',
            'Mensagem de erro exibida em tela',
            error
        )
    }, [error])

    const onChangeFilterStatesHandler = useCallback((filterKey: string) => {

        return setFilterStates((prevState: IFilterStates) => {
            let newState: IFilterStates | any = { ...prevState }

            for (let key in newState) {
                if (filterKey === key) {
                    if (newState[filterKey]) {
                        newState = { ...newState, [filterKey]: false }
                        continue
                    }

                    newState = { ...newState, [filterKey]: true }
                    continue
                }
                newState = { ...newState, [key]: false }
            }
            return newState
        })
    }, [])

    const onClearFilterhandler = useCallback(() => {
        onClearDataAndPaginate()
        onCloseAllModalSettingsHandler()
        return setFilter((prevState: IFilter) => ({ env: prevState?.env }))
    }, [onClearDataAndPaginate, onCloseAllModalSettingsHandler])

    const onClearCategoryhandler = useCallback(() => {
        onClearDataAndPaginate()
        onCloseAllModalSettingsHandler()
        return setCategory((prevState: ICategory) => ({ search: prevState?.search }))
    }, [onClearDataAndPaginate, onCloseAllModalSettingsHandler])

    const onClearOrderHandler = useCallback(() => {
        return setOrder({})
    }, [])

    const onClearAllhandler = useCallback(() => {
        onClearFilterhandler()
        onClearCategoryhandler()
    }, [onClearCategoryhandler, onClearFilterhandler])

    const onChangeOrderHandler = useCallback((key: string, value: string) => {
        if (order[key] === value) {
            onClearOrderHandler()
            onClearDataAndPaginate()
            onCloseAllModalSettingsHandler()
            return
        }

        onClearDataAndPaginate()
        setOrder((prevState: any) => ({ ...prevState, [key]: value }))
        onCloseAllModalSettingsHandler()
    }, [onClearDataAndPaginate, onClearOrderHandler, onCloseAllModalSettingsHandler, order])

    const onToggleZoomModal = useCallback(() => setIsOpenZoomModal(prevState => {
        if (prevState) {
            onEnableScrollHandler()
        } else {
            onDisabledScrollHandler()
        }
        return !prevState
    }), [])

    const onGetItemInformationsHandler = useCallback((data: IZoomModal) => {
        return setZoomModal(prevState => ({ ...prevState, ...data }))
    }, [])

    const footerButtonInfoMemo = useMemo(() => {
        if (wishListIsOpen && openedWishList.action === "create" && openedWishList.products.length <= 0)
            return {
                buttonComponent: (
                    <FooterButtonNameCreateWishListOut>
                        <span>Adicionar produtos depois</span>
                    </FooterButtonNameCreateWishListOut>
                ),
                onClick: onCloseWishListHandler,
            }

        if (wishListIsOpen && openedWishList.action === "create" && openedWishList.products.length > 0)
            return {
                buttonComponent: (
                    <FooterButtonNameCreateWishList>
                        <span>Adicionar produtos ({openedWishList.products.length})</span>
                    </FooterButtonNameCreateWishList>
                ),
                onClick: onOpenModalSuccessHandler
            }

        if (wishListIsOpen && openedWishList.action === "edit")
            return {
                buttonComponent: (
                    <FooterButtonNameCreateWishList>
                        <span>Finalizar  ({openedWishList.products.length})</span>
                    </FooterButtonNameCreateWishList>
                ),
                onClick: onOpenModalSuccessHandler
            }

        if (!wishListIsOpen)
            return {

                buttonComponent: (
                    <FooterButtonNameCreateWishList>
                        <PlusSvg />
                        <span>Criar lojinha</span>
                    </FooterButtonNameCreateWishList>
                ),
                onClick: () => null,

            }

        return {
            buttonComponent: <></>,
            onClick: () => null
        }
    }, [wishListIsOpen, openedWishList.action, openedWishList.products.length, onCloseWishListHandler, onOpenModalSuccessHandler])

    const modalSuccesInformationsMemo = useMemo(() => (
        {
            tittle: `Lojinha ${openedWishList.action === 'create' ? 'criada' : 'editada'}!`,
            onClick: onClickActionModalSuccessHandler,
            textWishList: `${openedWishList.name} foi ${openedWishList.action === 'create' ? 'criada' : 'editada'} com sucesso. Começe a compartilhar por aí!`
        }
    ), [onClickActionModalSuccessHandler, openedWishList.name, openedWishList.action])

    const endMessagePaginate = React.createElement(
        'div',
        {
            style: { color: '#FAFAFA', display: 'flex', flexDirection: 'column', textAlign: 'center' }
        },
        <>Combinação de filtros ou pesquisas não encontrados</>,
        <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
            <Button
                className='btn__endMessage--limpar'
                name={<span><CloseButtonSvg />limpar</span>}
                onClick={() => {
                    onClearAllhandler()
                    onClearDataAndPaginate(true)
                    SendGTAGEvent(
                        'limpa_filtros',
                        'Filtro',
                        'Clicou em "limpar" - produtos não encontrados')
                }
                }>
            </Button>
            <Button
                className='btn__endMessage--pesquisar'
                name={<span><SearchSvg />nova busca</span>}
                onClick={() => {
                    onOpenCloseSearchHandler()
                    SendGTAGEvent(
                        'botao_nova-busca',
                        'Pesquisa',
                        'Clicou em "nova busca"')
                }
                }>
            </Button>
        </div>
    )

    useEffect(() => {
        if (storedEnv === 'null' || storedEnv === null || storedEnv === '') {
            setLoading(false)
            localStorage.setItem('env', filter.env)
        }
        if (userBrandsMemo.length === 1) { localStorage.setItem('env', userBrandsMemo[0].filterItemValue) }
    }, [filter, filter.env, filter.length, openedWishList.vtexBrandName, setShouldHideDeviceFilterBrand, userBrandsMemo, wishListIsOpen])

    useEffect(() => {
        switch (filter.env) {
            case 'lojaoffpremium':
                if (!windowScreenWidth()) {
                    setShouldHideBrand(false);
                    setShouldHideNews(true);
                } else {
                    setShouldHideDeviceFilterBrand(false);
                }
                break;
            case 'lojafarm':
                if (!windowScreenWidth()) {
                    setShouldHideCategory(false);
                    setShouldHideNews(false);
                } else {
                    setShouldHideCategory(false);
                    setShouldHideNews(false);
                    setShouldHideDeviceFilterCategory(false);
                    setShouldHideDeviceFilterNews(false);
                    setFilter((prevState: any) => ({ ...prevState, search: 'todos' }))
                }
                break;
            case 'mariafilo':
                if (!windowScreenWidth()) {
                    setShouldHideCategory(false);
                } else {
                    setShouldHideCategory(false);
                    setShouldHideDeviceFilterCategory(false);
                }
                break;
            default:
                break;
        }
    }, [filter.env]);

    useEffect(() => {
        onShowButtonSearchHandler(true)
        return () => onShowButtonSearchHandler(false)
    }, [onShowButtonSearchHandler])

    useEffect(() => {
        mounted.current = true

        if (userBrandsMemo.map(item => item.filterItemValue).includes(filter.env)) {
            onFetchDataHandler()
        }
        return () => { mounted.current = false };
    }, [filter, onFetchDataHandler, userBrandsMemo])

    useEffect(() => {
        if (wishListIsOpen && openedWishList.vtexBrandName) {
            setFilter((prevState: any) => ({ ...prevState, env: openedWishList.vtexBrandName }))
        }
    }, [openedWishList.vtexBrandName, wishListIsOpen])

    useEffect(() => {
        if (userBrandsMemo.some(x => x.filterItemValue === filter.env)) {
            setIsOpenProducts(false)
        }
    }, [wishListIsOpen, userBrandsMemo, filter.env])

    useEffect(() => {
        if (!wishListIsOpen) {
            onOpenNpsHandler()
        }
    }, [wishListIsOpen, onOpenNpsHandler])

    return (
        <Container>
            <Tutorial />
            {!loading && <Home isOpen={isOpenProducts} filterItems={userBrandsMemo}
                setfilterProperties={setFilter}
                filterName={'env'}
                className={'products'}
            />}
            <ProductZoomModal
                isModalVisible={isOpenZoomModal}
                onBackdropClick={onToggleZoomModal}
                informations={zoomModal}
            />
            {paginateParams.searchedText &&
                <ContainerTextSearch>
                    <TextSearchItem>
                        <span>Resultados para "{paginateParams.searchedText}"</span>
                        {data.length > 0 && !loading &&
                            <button onClick={() => onClearDataAndPaginate(true)}>
                                x<span>Limpar</span>
                            </button>
                        }
                    </TextSearchItem>
                </ContainerTextSearch>
            }

            <Nps
                isOpen={isOpenNps}
                onClose={onCloseNpsHandler} />
            <Search
                isOpen={isOpenSearch}
                onClose={onOpenCloseSearchHandler}
                searchedText={paginateParams.searchedText}
                onSearch={onSearchTextHandler}
            />
            <ModalMessage
                optionSVG="errorImage"
                textWishList={error}
                tittle="Oops..."
                isOpen={!!error}
                onClose={onClearErrorHandler}
            />

            <ModalMessage
                optionSVG="successImage"
                textWishList={modalSuccesInformationsMemo.textWishList}
                tittle={modalSuccesInformationsMemo.tittle}
                isOpen={successModalIsOpen}
                onClick={modalSuccesInformationsMemo.onClick}
                onClose={onCloseModalSuccessHandler} />

            {
                wishListIsOpen ? openedWishList.action === "create"
                    ? <WishListTitle> 2. Escolha seus produtos </WishListTitle> : <WishListTitle> Editar produtos </WishListTitle> : null
            }

            <ContentBetweenLines>
                <ProductsHeaderContainer className='home'>
                    <SettingsContainer
                        filter={filter}
                        order={order}
                        filterConfigs={filterConfigsMemo}
                        filterConfigsCategory={filterConfigsCategoryMemo}
                        orderConfigs={orderConfigsMemo.orderMobileConfigs}
                        isOpen={isOpenModalsSettings}
                        onCloseModal={onOpenAndCloseModalSettingsHandler}
                        onClick={onOpenAndCloseModalSettingsHandler}
                        onChangeFilterStatesHandler={onChangeFilterStatesHandler}
                        setFilter={setFilter}
                        setFilterCategorys={setCategory}
                        onClearPage={onClearDataAndPaginate}
                        onClearFilter={onClearFilterhandler}
                        onClearCategory={onClearCategoryhandler}
                        activeFiltersCount={activeFiltersCounteMemo}
                        activeCategoryCount={activeCategoryCounteMemo}
                        className="settings--container"
                        shouldUseArrow
                        onOrderHandler={onChangeOrderHandler} />
                </ProductsHeaderContainer>
            </ContentBetweenLines>
            <Paginate endMessage={endMessagePaginate} loading={loading} dataLength={data.length} hasMore={checkIfHasMore} next={onNextPaginateHandler}>
                <ProductsCardList
                    shouldUseNewTag
                    products={data}
                    currentBrand={filter.env}
                    amountItems={5}
                    onGetInformationZoomModal={onGetItemInformationsHandler}
                    onOpenZoomModal={onToggleZoomModal}
                    sellerCode={userInfo.code}
                />
            </Paginate>
            <ButttonTop color={'#DBC7B8'} isVisible={isVisibleButtonTop} backgroundColor={'#363435'} borderRadius={'5px'} />

            <FooterButton
                classNameButton={`btn__footerbtn--button ${wishListIsOpen && openedWishList.products.length <= 0 && openedWishList.action === 'create' && 'btn__footerbtnout--button'}`}
                name={footerButtonInfoMemo?.buttonComponent}
                onClick={footerButtonInfoMemo?.onClick}
                to={!wishListIsOpen ? "/create-wishlist" : undefined} />
        </Container>
    )
}

export default Products 